import {
  ButtonV3,
  GridItem,
  LayoutGrid,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';

import ArtDirectionImage from '@/app/components/Image/ArtDirectionImage';
import Em from '@/app/components/LegacyLandingPage/components/Em';
import RichText from '@/app/components/RichText';

const tValue = {
  i: function i(chunks: ReactNode) {
    return <Em>{chunks}</Em>;
  },
};

const CallToAction = () => {
  const t = useTranslations();
  return (
    <section>
      <LayoutGrid>
        <GridItem
          className="relative"
          colEnd={{ sm: 'full' }}
          colStart={{ sm: 'full' }}
          rowEnd={{ sm: 2 }}
          rowStart={{ sm: 1 }}
        >
          <ArtDirectionImage
            alt=""
            className="object-cover"
            fill
            format="png"
            sizes="100vw"
            srcSet={[
              {
                src: 'developer/shop-banner_mobile',
                media: '(max-width: 767px)',
              },
              {
                src: 'developer/shop-banner_desktop',
                media: '(min-width: 768px)',
              },
            ]}
          />
        </GridItem>
        <GridItem
          className="relative flex flex-col justify-center pt-20 pb-64 text-gray-600 md:py-44"
          colEnd={{ sm: 'main', md: 12 }}
          colStart={{ sm: 'main' }}
          rowEnd={{ sm: 2 }}
          rowStart={{ sm: 1 }}
        >
          <TypographyV3
            Element="h3"
            variant="h3"
            color="inherit"
            height="tight"
            className="mb-9 max-w-80 text-[3.75rem] md:mb-6 lg:mb-9 lg:max-w-[30rem]"
          >
            <RichText messageKey="developer_ready_to_start" tValues={tValue} />
          </TypographyV3>
          <div>
            <ButtonV3
              variant="secondary-light"
              href="https://cloud.ouraring.com/v2/docs"
              target="_blank"
              rel="noreferrer"
            >
              {t('developer_hero_cta')}
            </ButtonV3>
          </div>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default CallToAction;
